var map = {
	"./angry.svg": "8611",
	"./confused.svg": "0742",
	"./excited.svg": "29e9",
	"./neutral.svg": "160e",
	"./panic.svg": "69b0",
	"./upset.svg": "871f",
	"./wondering.svg": "ae12",
	"./worried.svg": "ace1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a76b";